var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "推荐机构", name: "first" } },
            [
              _c("swb-servc-work-voucher-ds-assign-shop-select", {
                ref: "swb_servc_work_ds_assign_shop",
                attrs: {
                  merchantId: _vm.merchantId,
                  comId: _vm.comId,
                  comLevel: _vm.comLevel,
                  voucherId: _vm.voucherId,
                  buyerShopLat: _vm.buyerShopLat,
                  buyerShopLng: _vm.buyerShopLng,
                  servcId: _vm.servcId,
                  servcType: _vm.servcType,
                  buyerShopId: _vm.buyerShopId,
                  devcCatId: _vm.devcCatId,
                  servcCatId: _vm.servcCatId
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "全部机构", name: "all" } },
            [
              _c("swb-org-tree", {
                ref: "swb_retail_org_tree",
                attrs: {
                  enableSearch: true,
                  isRadio: true,
                  accordion: true,
                  merchantId: _vm.merchantId,
                  isCom: true
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63bc2006", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63bc2006","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/workVoucher/ServcWorkVoucherDispatchShopSelect.vue
// module id = 2003
// module chunks = 1